<template>
  <div
    class="card supply"
    @click="goToSupply"
    :class="
    {
      'supply--gas': supply.supplyTypeCode === 'GAS',
      'supply--energy': supply.supplyTypeCode === 'EE',
      'supply--payment': mode === 'payment',
    }
  ">
    <img v-if="supply.supplyTypeCode === 'EE' && mode != 'payment'" src="../assets/illustration-luce-white.png" class="card-img-top" alt="...">
    <img v-if="supply.supplyTypeCode === 'GAS' && mode != 'payment'" src="../assets/illustration-gas-white.png" class="card-img-top" alt="...">

    <div class="card-body" v-if="mode === 'view'">
      <h5 class="card-title small-text">{{ $t("supply.number") }}</h5>
      <p class="card-text medium-text">{{ supply.SupplyPoint }}</p>
      <span class="card-text small-text" style="margin-bottom: 15px;">{{ supply.address }}</span>
    </div>
    <div class="card-body" v-if="mode === 'view'">
      <p v-if="supply.invoiceId != null" class="card-text small-text" style="margin-bottom: 5px;">{{ $t("supply.lastInvoice") }}</p>
      <h3 v-if="supply.totalValue != null" class="card-title price">€ {{ formatFloat(supply.totalValue) }}</h3>
      <p v-if="supply.expirationDate != null" class="card-text small-text expiry">{{ $t("supply.expiry") }} {{ $moment(supply.expirationDate).format('DD/MM/YYYY') }}</p>
    </div>

    <div class="card-body-payment" v-if="mode === 'payment'">    
      <div v-if="supply.supplyTypeCode === 'EE'" style="display: flex;flex-direction: row;">
        <img v-if="supply.supplyTypeCode === 'EE'" src="../assets/illustration-luce-white.png" class="card-img-top" alt="..." style="height: 47px;width: 47px;">
        <div style="margin-left: 8px;padding-top: 8px;">
          <div style="height: 10;width: 100%;background-color: red;"></div>
          <h5 class="small-text">
            {{ $t("supply.supplyEE_txt")}}
            <br />
            <b>{{ supply.supplyPoint }}</b>
          </h5>
        </div>
      </div>
      <div v-if="supply.supplyTypeCode === 'GAS'" style="display: flex;flex-direction: row;">
       <img v-if="supply.supplyTypeCode === 'GAS'" src="../assets/illustration-gas-white.png" class="card-img-top" alt="..." style="height: 47px;width: 47px;">
        <div style="margin-left: 8px;padding-top: 8px;">
          <h5 class="small-text">
            {{$t("supply.supplyGas_txt")}}
            <br />
            <b>{{ supply.supplyPoint }}</b>
          </h5>
        </div>
      </div>
      <div style="padding-top: 12px;">
         <span class="expiry">{{ $t("supply.paymentBplInvoiceNumber", { number: supply.invoiceNumber, date: $moment(supply.invoiceDate).format('DD/MM/YYYY')}) }}
          </span>
      </div>
      <div style="margin-top: 4px;">
        <h3 style="margin-bottom: 0;">€ {{ formatFloat(supply.totalValue) }}</h3>
        {{ $t("supply.expiry") }} {{ $moment(supply.expirationDate).format('DD/MM/YYYY') }}
      </div>
      <div v-if="(supply.paymentStatus == 'PAID' || supply.paymentStatus == 'NOTPAID' || supply.paymentStatus == 'PARTIAL' || supply.paymentStatus == 'COMPENS' || (supply.paymentStatus == 'PENDING' && supply.paymentLabel != undefined && supply.paymentLabel != null && supply.paymentLabel.length > 0))" style="width: 100%;height: 1px;background-color: white;margin-top: 12px;margin-bottom: 12px;"></div>
      <div style="display:flex; flex-direction: row;" v-if="supply.paymentStatus == 'PAID' || supply.paymentStatus == 'NOTPAID' || supply.paymentStatus == 'PARTIAL' || supply.paymentStatus == 'COMPENS'">
        <div :style="{display:'flex',alignItems: 'center',justifyContent:'center',maxHeight:'26px',maxWidth:'26px',borderRadius:'50%',backgroundColor: supply.paymentStatus == 'PAID' ? 'green' : (supply.paymentStatus == 'NOTPAID' ? 'red' : supply.paymentStatus == 'COMPENS' ? 'green' : 'partial') }">  
          <img style="max-width: 26px;max-height: 26px;"  v-if="supply.paymentStatus == 'COMPENS'" :src="icoCheck" />
          <img style="max-width: 26px;max-height: 26px;"  v-if="supply.paymentStatus == 'PAID'" :src="icoCheck" />
          <img style="max-width: 26px;max-height: 26px;" v-if="supply.paymentStatus == 'NOTPAID'" :src="icoKo" />
          <img style="max-width: 26px;max-height: 26px;" v-if="supply.paymentStatus == 'PARTIAL'" :src="icoKo" />
        </div>
        <div style="margin-top: 2px;margin-left: 6px;display: flex;flex-direction: row;">
            <div @click="showNoteList(supply)" style="align-items: center;justify-content: center;">
             
            <span style="font-size: 15px;" v-if="supply.totalValue < 0"><b>{{ $t("supply.paymentNegative").toUpperCase() }}</b></span>
            <span style="font-size: 15px;" v-if="supply.paymentStatus === 'PAID' && supply.totalValue >= 0"><b>{{ $t("supply.paymentOK").toUpperCase() }}</b></span>
            <span style="font-size: 15px;" v-if="supply.paymentStatus === 'NOTPAID' && supply.totalValue >= 0"><b>{{ $t("supply.paymentKO").toUpperCase() }}</b></span>
            <span style="font-size: 15px;" v-if="supply.paymentStatus === 'PARTIAL' && supply.totalValue >= 0"><b>{{ $t("supply.paymentPartial").toUpperCase() }}</b></span>
            <span style="font-size: 15px;" v-if="supply.paymentStatus === 'INPAYMENT' && supply.totalValue >= 0"><b>{{ supply.paymentButtonLabel?.toUpperCase() }}</b></span>
            </div>
          <div @click="showNoteList(supply)" style="align-items: center;justify-content: center;">
               <span v-if="supply.notes.length > 0">
                <img :src="icoKo" width="18" height="18" style="margin-top: -3px;margin-right: 5px;" />
              </span>
            </div>
        </div>
      </div>
     
      <div class="card-text small-text payment-details">
               
       <div style="padding-left: 36px;margin-top: -5px;">
            <span>{{ supply.paymentLabel }}</span>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import icoCheck from '../assets/ico-check-white.svg'
import icoKo from '../assets/ico-attetion-white.svg'

export default {
  name: 'Supply',
  props: {
    supply: Object,
    mode: {
      type: String,
      default: 'view'
    }
  },
  data: function () {

    let active = this.isActive();

    return {
      icoCheck: icoCheck,
      icoKo: icoKo,
      active:active,
    }
  },
  methods: {
    showNoteList: function(supply) {
      console.log(supply);
      this.$store.commit('setNoteList', supply.notes);
      this.$store.commit('setTitleNoteList',this.$t("supply.invoiceNumberNoDate",{number: supply.invoiceNumber}));
      event.stopPropagation();
    },
    isActive: function() {
      var active = false;

      const userContract = this.$store.state.currentUserContract;

      const supplies = userContract.supplyPoints;

      for (let index = 0; index < supplies.length; index++) {
        const element = supplies[index];

      
        if (this.supply.supplyPoint != undefined && this.supply.supplyPoint != null) {
          if (element.supplyPoint == this.supply.supplyPoint) {
            active = element.active;
            break;
          }
        } else if (this.supply.SupplyPoint != undefined && this.supply.SupplyPoint != null) {
          if (element.supplyPoint == this.supply.SupplyPoint) {
            active = element.active;
            break;
          }
        }

       

      }
      
      return active;
    },
    goToSupply: function() {
       this.$store.commit('setFromHome',false);
      this.$store.commit('setSupply', this.supply)
      this.$router.push('/bolletta/' + this.supply.supplyTypeCode + '/' + this.supply.invoiceId)
    }
  },
  computed: {
    supplyType: function () {
      return this.supply.supplyTypeCode === 'GAS' ? this.$t('supply.supplyGas') : this.$t('supply.supplyEE')
    }
  }
}
</script>
<style lang="scss" scoped>
.supply {
  padding: 16px;
  border: none;
  color: #fff;
  border-radius: 4px;
  width: 100%;
  cursor: pointer;

  &-icon {
    position: absolute;
    top: 25px;
    right: 25px;
    border-radius: 50%;
    padding: 2px;
    line-height: 1;

    &--paid {
      background-color: var(--green);
    }

    &--not-paid {
      background-color: var(--red);
    }

    &--partial {
      background-color:  var(--payment-partial);
    }
  }

  &-icon-payment {
    border-radius: 50%;
    padding: 2px;

    &--paid {
      background-color: var(--green);
    }

    &--not-paid {
      background-color: var(--red);
    }

    &--partial {
      background-color:  var(--payment-partial);
    }
  }

  .card-img-top {
    max-width: 47px;
    height: auto;
  }

  .card-body {
    padding: 20px 0 0;
  }

  .card-body-payment {
    padding: 5px 0 0;
  }

  &-active {
    font-size: 14px;
    font-weight: normal;
    line-height: normal;
  }

  .price {
    line-height: 1;
    margin-bottom: 5px;
  }

  .expiry {
    font-weight: 300;
  }

  .payment {
    margin-top: 8px;

    &-details {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 300;
      line-height: normal;
      letter-spacing: normal;
      color: var(--white);

    }
  }

  &--payment {
    margin-bottom: 24px;

    .price {
      margin-top: 15px;
    }
  }

  &--energy {
    background-image: var(--gradient-energy);
  }

  &--gas {
    background-image: var(--gradient-gas);
  }
}
</style>